import * as React from 'react';
import { useEffect } from 'react';
import { Assets, Product } from 'components/Catalog/Interfaces/List/IListResponse';
import Products from 'components/Catalog/Product/ListView/Products';
import { IGtmList } from 'components/SeoSuite/interfaces/IGtmEventDetail';
import { dispatchViewItemList } from 'components/SeoSuite/helpers/gtmEvents';
import { toGtmProducts } from 'components/SeoSuite/helpers/catalogProducts';

interface IProps {
    config: {
        products?: Product[];
        assets?: Assets;
        list?: IGtmList;
    };
}

export const ProductsGrid = (props: IProps) => {
    const { products, assets, list } = props.config;

    useEffect(() => {
        if (list && products?.length) {
            dispatchViewItemList(list, toGtmProducts(products, list));
        }
    }, [products]);

    if (!products || !products.length) {
        return <React.Fragment />;
    }

    return <Products products={products} assets={assets} list={list} ignoreListView={true} />;
};
